function doesFacetHasSelections() {
  const FWP = window.FWP;
  let facetSelections = false;

  if (FWP) {
    Object.values(FWP.facets).forEach(function (facet) {
      if (0 < facet.length) {
        facetSelections = true;
      }
    });
  }

  return facetSelections;
}

document.addEventListener('facetwp-loaded', () => {
  const selectionsWrapper = document.querySelector('.selectionsWrapper');
  const hasSelections = doesFacetHasSelections();

  if (selectionsWrapper) {
    if (hasSelections) {
      selectionsWrapper.classList.add('visible');
    } else {
      selectionsWrapper.classList.remove('visible');
    }
  }
});
